import { css } from "@emotion/react";
import { useMessage } from "@hermes/intl";
import { cssFns, usePrincipalColors } from "@hermes/ui";
import { ArrowDown, ArrowUp } from "@hermes/ui/src/button/icons";
import { DropdownBody } from "@hermes/ui/src/dropdown-menu/dropdown-body";
import { useRef, useState } from "react";

import { AccountCircle } from "./icons";

export const LoginButton = () => {
  const principalColors = usePrincipalColors();
  const message = useMessage();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownBody isOpen={isOpen} onToggle={setIsOpen}>
      {({ open, toggleDropdown }) => (
        <>
          <div
            ref={containerRef}
            onClick={() => {
              toggleDropdown();
            }}
            css={css({
              position: "relative",
              zIndex: 2000,
              display: "flex",
              gap: 6,
              alignItems: "center",
              "&:hover": {
                cursor: "pointer",
              },
            })}
          >
            <AccountCircle />
            <div
              css={{
                marginLeft: "4px",
              }}
            >
              {message({
                id: "d3c493e2-9da2-438e-8601-fec079322bea",
                default: "Войти",
              })}
            </div>
            {!open && <ArrowDown />}
            {open && <ArrowUp />}
          </div>

          {open && (
            <div
              css={[
                {
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  marginTop: "10px",
                  padding: "16px 10px",
                  minWidth: 220,
                  color: principalColors.gs2,
                  zIndex: 2000,
                  backgroundColor: principalColors.white,
                  border: `1px solid ${principalColors.grayline}`,
                  borderRadius: "4px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    cursor: "default",
                  },
                },
              ]}
            >
              <ul
                css={{
                  padding: 0,
                  li: {
                    listStyle: "none",
                    padding: "12px 0",
                    borderBottom: `1px solid ${principalColors.grayline}`,
                    "&:first-of-type": {
                      paddingTop: 0,
                    },
                    "&:last-of-type": {
                      paddingBottom: 0,
                      borderBottom: "none",
                    },
                  },
                  p: [
                    cssFns.typo({
                      level: "body-1",
                      weight: "regular",
                    }),
                    {
                      marginBottom: "8px",
                    },
                  ],
                  a: {
                    textDecoration: "none",
                    color: principalColors.ebblue,
                    "&:hover": {
                      cursor: "pointer",
                    },
                  },
                }}
              >
                {/* <li>
                  <p>
                    {message({ id: "abdb18ec-cd4d-49c4-bf8f-531a90394cba" })}
                  </p>

                  <a
                    href="/"
                    css={{
                      pointerEvents: "none",
                      opacity: 0.5,
                    }}
                  >
                    {message({
                      id: "d3c493e2-9da2-438e-8601-fec079322bea",
                    })}
                  </a>
                </li> */}
                <li>
                  <p>
                    {message({ id: "cfdb78f3-8765-4ac3-b954-f84542fbb335" })}
                  </p>

                  <a href={import.meta.env.DOQ_CABINET_URL} target="_blank">
                    {message({
                      id: "d3c493e2-9da2-438e-8601-fec079322bea",
                    })}
                  </a>
                </li>
              </ul>
            </div>
          )}
        </>
      )}
    </DropdownBody>
  );
};
